import Mitt from 'mitt';

export const EVENT = {
  SET_SHARE_CONTENT: 'SET_SHARE_CONTENT',
  USER_STATUS_401: 'USER_STATUS_401',
  GOT_USER_INFO: 'got_user_info'
};

export default new Mitt();
